import { Box, CircularProgress, LinearProgress } from '@mui/material';

import { ProgressBarThemes } from '../../constants';

import type { LinearProgressProps } from '@mui/material';

interface ProgressBarProps {
  type?: string;
  sx?: any;
  color?: LinearProgressProps['color'];
}

const FProgressBar = (props: ProgressBarProps) => {
  const { type = 'linear', sx, color = ProgressBarThemes.Primary } = props;

  const renderProgressBar = () => {
    switch (type) {
      case 'linear':
        return (
          <Box sx={{ flexGrow: 1 }}>
            <LinearProgress color={color} />
          </Box>
        );
      case 'circular':
        return (
          <Box sx={{ flexGrow: 1 }}>
            <CircularProgress color={color} />
          </Box>
        );
      default:
        return (
          <Box sx={{ flexGrow: 1 }}>
            <LinearProgress color={color} />
          </Box>
        );
    }
  };

  return (
    <Box sx={{ position: 'fixed', top: 0, left: 0, width: '100vw', zIndex: 10, ...sx }}>
      {renderProgressBar()}
    </Box>
  );
};

export default FProgressBar;
